const CLOUDINARY_UPLOAD_SEGMENT = '/image/upload/';

/**
 * Display-only Cloudinary URL rewrite. Does not mutate stored originals.
 * Inserts `transform` immediately after /image/upload/.
 * Returns the original URL when the input is not a transformable Cloudinary image URL.
 */
export function getCloudinaryDeliveryUrl(url, transform) {
  if (!url || typeof url !== 'string' || !transform) {
    return url;
  }

  try {
    if (
      !url.includes('res.cloudinary.com') ||
      !url.includes(CLOUDINARY_UPLOAD_SEGMENT)
    ) {
      return url;
    }

    const insertAt =
      url.indexOf(CLOUDINARY_UPLOAD_SEGMENT) + CLOUDINARY_UPLOAD_SEGMENT.length;
    const afterUpload = url.slice(insertAt);

    if (
      afterUpload.startsWith(`${transform}/`) ||
      afterUpload.startsWith(`${transform},`)
    ) {
      return url;
    }

    return `${url.slice(0, insertAt)}${transform}/${afterUpload}`;
  } catch (error) {
    return url;
  }
}
